import angular from 'angular'

// components
import asyncAudio from './component/asyncAudio.js'

export default angular
  .module('portalApp.asyncAudio', [])
  .component('asyncAudio', asyncAudio).name
